// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-fetch';
import type { SaveReportData, SaveReportResponse, SaveReportError, GetReportStatusCheckData, GetReportStatusCheckResponse, GetReportStatusCheckError, GetReportHistoryListData, GetReportHistoryListResponse, GetReportHistoryListError, GetReportHistoryData, GetReportHistoryResponse, GetReportHistoryError, GetLoanInterestListData, GetLoanInterestListResponse, GetLoanInterestListError, HealthCheckData, HealthCheckResponse, HealthCheckError, RenewalEncKeyData, RenewalEncKeyResponse, RenewalEncKeyError, GetEligibilityCheckData, GetEligibilityCheckResponse, GetEligibilityCheckError, SendDeptReportAppPushData, SendDeptReportAppPushResponse, SendDeptReportAppPushError, RenewalApiKeyData, RenewalApiKeyResponse, RenewalApiKeyError, IssuanceApikeyData, IssuanceApikeyResponse, IssuanceApikeyError, GetAddressData, GetAddressResponse, GetAddressError, SendJejuYouthDreamServiceData, SendJejuYouthDreamServiceResponse, SendJejuYouthDreamServiceError, SaveExternalClientData, SaveExternalClientResponse, SaveExternalClientError, GetUniversityListData, GetUniversityListResponse, GetUniversityListError, GetNoticeData, GetNoticeResponse, GetNoticeError, GetIclLoanInterestChangeHisData, GetIclLoanInterestChangeHisResponse, GetIclLoanInterestChangeHisError, GetCountryListData, GetCountryListResponse, GetCountryListError, GetAgreementData, GetAgreementResponse, GetAgreementError, GetWelloPolicyApplyHisListData, GetWelloPolicyApplyHisListResponse, GetWelloPolicyApplyHisListError } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * 채무자신고 내역 저장 (각종 정보 제공 동의 및 채무자신고내역 저장)
 */
export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreport = <ThrowOnError extends boolean = false>(options: Options<SaveReportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveReportResponse, SaveReportError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/report',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 귀속연도의 정기 채무자신고 완료여부 조회
 */
export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHstatusDASHcheck = <ThrowOnError extends boolean = false>(options: Options<GetReportStatusCheckData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetReportStatusCheckResponse, GetReportStatusCheckError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/report-status-check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 채무자신고 이력 목록 조회
 */
export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHlist = <ThrowOnError extends boolean = false>(options: Options<GetReportHistoryListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetReportHistoryListResponse, GetReportHistoryListError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/report-history/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 채무자신고 신고 내용중 단건 상세 조회(신고내역 상세내역조회)
 */
export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHreportDASHhistorySLASHdetail = <ThrowOnError extends boolean = false>(options: Options<GetReportHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetReportHistoryResponse, GetReportHistoryError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/report-history/detail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 채무자신고대상자 대출 이자 조회 (취업후 학자금대출 전월말 기준 이자 조회)
 */
export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHloanDASHinterest = <ThrowOnError extends boolean = false>(options: Options<GetLoanInterestListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetLoanInterestListResponse, GetLoanInterestListError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/loan-interest',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * kosaf health-check
 */
export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHhealthDASHcheck = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<HealthCheckResponse, HealthCheckError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/health-check',
        ...options
    });
};

/**
 * kosaf 암호화 키 갱신
 */
export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHenckeyDASHrenewal = <ThrowOnError extends boolean = false>(options?: Options<RenewalEncKeyData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RenewalEncKeyResponse, RenewalEncKeyError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/enckey-renewal',
        ...options
    });
};

/**
 * 신고가능여부 조회
 */
export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHeligibilityDASHcheck = <ThrowOnError extends boolean = false>(options: Options<GetEligibilityCheckData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetEligibilityCheckResponse, GetEligibilityCheckError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/eligibility-check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 앱 푸시 발송 요청
 */
export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHappDASHpush = <ThrowOnError extends boolean = false>(options: Options<SendDeptReportAppPushData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SendDeptReportAppPushResponse, SendDeptReportAppPushError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/app-push',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * kosaf API 키 재발급
 */
export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHrenewal = <ThrowOnError extends boolean = false>(options?: Options<RenewalApiKeyData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RenewalApiKeyResponse, RenewalApiKeyError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/apikey-renewal',
        ...options
    });
};

/**
 * kosaf API 키 & 암호화 키 발급
 */
export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHapikeyDASHissuance = <ThrowOnError extends boolean = false>(options: Options<IssuanceApikeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IssuanceApikeyResponse, IssuanceApikeyError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/apikey-issuance',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 채무자신고 대상자 주소정보 조회
 */
export const postMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHaddress = <ThrowOnError extends boolean = false>(options: Options<GetAddressData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetAddressResponse, GetAddressError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/address',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 제주청년드림 상담 신청 등록
 */
export const postMETHODSLASHwelloSLASHv1SLASHallowsSLASHjejuDASHyouthDASHdream = <ThrowOnError extends boolean = false>(options: Options<SendJejuYouthDreamServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SendJejuYouthDreamServiceResponse, SendJejuYouthDreamServiceError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/allows/jeju-youth-dream',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 외부 클라이어트 생성 요청
 */
export const postMETHODSLASHwelloSLASHv1SLASHallowsSLASHexternalDASHclient = <ThrowOnError extends boolean = false>(options: Options<SaveExternalClientData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveExternalClientResponse, SaveExternalClientError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/allows/external-client',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 재단 대학명 조회
 */
export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHuniversity = <ThrowOnError extends boolean = false>(options: Options<GetUniversityListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUniversityListResponse, GetUniversityListError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/university',
        ...options
    });
};

/**
 * 채무자신고 공지사항 조회
 */
export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHnotice = <ThrowOnError extends boolean = false>(options: Options<GetNoticeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetNoticeResponse, GetNoticeError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/notice',
        ...options
    });
};

/**
 * ICL대출상품의 금리변동내역 조회
 */
export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHiclDASHloanDASHinterestDASHchangeDASHhistory = <ThrowOnError extends boolean = false>(options?: Options<GetIclLoanInterestChangeHisData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetIclLoanInterestChangeHisResponse, GetIclLoanInterestChangeHisError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/icl-loan-interest-change-history',
        ...options
    });
};

/**
 * 재단 국가명 조회
 */
export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHcountry = <ThrowOnError extends boolean = false>(options: Options<GetCountryListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCountryListResponse, GetCountryListError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/country',
        ...options
    });
};

/**
 * 소득 및 재산 정보 제공 동의 약관 조회
 */
export const getMETHODSLASHwelloSLASHv1SLASHdeptDASHreportingSLASHagreement = <ThrowOnError extends boolean = false>(options?: Options<GetAgreementData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAgreementResponse, GetAgreementError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/dept-reporting/agreement',
        ...options
    });
};

/**
 * 정책 신청 목록 API
 */
export const getMETHODSLASHwelloSLASHv1SLASHallowsSLASHpolicyDASHapplyDASHhisSLASHLBRACEmemberOAuthIdRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetWelloPolicyApplyHisListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWelloPolicyApplyHisListResponse, GetWelloPolicyApplyHisListError, ThrowOnError>({
        security: [
            {
                name: 'x-wello-access-key',
                type: 'apiKey'
            },
            {
                name: 'x-wello-timestamp',
                type: 'apiKey'
            },
            {
                name: 'x-wello-signature',
                type: 'apiKey'
            }
        ],
        url: '/wello/v1/allows/policy-apply-his/{memberOAuthId}',
        ...options
    });
};